// Copyright 2026 FlairCV Contributors
// SPDX-License-Identifier: AGPL-3.0-or-later

import { z } from 'zod';

const CATEGORIES = ['technical', 'soft', 'tool', 'certification', 'language'] as const;
const PROFICIENCIES = ['beginner', 'intermediate', 'advanced', 'expert'] as const;

/** Schema for creating/editing a skill. */
export const skillSchema = z.object({
  name: z
    .string()
    .min(1, 'Name is required.')
    .max(255, 'Name must be at most 255 characters.'),
  category: z
    .string()
    .min(1, 'Category is required.')
    .max(100, 'Category must be at most 100 characters.'),
  proficiency: z
    .string()
    .max(50, 'Proficiency must be at most 50 characters.')
    .optional()
    .or(z.literal('')),
  years_experience: z
    .string()
    .optional()
    .or(z.literal('')),
});

export type SkillFormData = z.infer<typeof skillSchema>;
export { CATEGORIES, PROFICIENCIES };
